import { InjectionToken } from "@angular/core";
import { BankAccountsPort } from "./bank-accounts.port";

export const TREASURY_BANK_ACCOUNTS_PORT =
  new InjectionToken<BankAccountsPort>("TREASURY_BANK_ACCOUNTS_PORT");
